var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';
import { Field } from 'react-redux-form';
import { connect } from 'react-redux';
import { t, Translate } from "../../I18N";

import { checkErrorsOnLabel } from "../utils/checkErrorsOnLabel";
import PropertyConfigOptions from "./PropertyConfigOptions";






const mapStateToProps = (state, ownProps) => {
  const { template } = state;
  return {
    property: template.data.properties ? template.data.properties[ownProps.index] : undefined,
    index: ownProps.index,
    type: ownProps.type,
    labelHasError: checkErrorsOnLabel(state, ownProps)
  };
};

const connector = connect(mapStateToProps);



const FormConfigDateComponent = ({ index, type, labelHasError, property }) => /*#__PURE__*/
_jsx("div", {}, void 0, /*#__PURE__*/
_jsx("div", { className: `form-group${labelHasError ? ' has-error' : ''}` }, void 0, /*#__PURE__*/
_jsx("label", { htmlFor: "property-label" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Label")
), /*#__PURE__*/
_jsx(Field, { model: `template.data.properties[${index}].label` }, void 0, /*#__PURE__*/
_jsx("input", { className: "form-control", id: "property-label" })
)
), /*#__PURE__*/

_jsx("div", { className: "form-group" }, void 0, /*#__PURE__*/
_jsx("label", { htmlFor: "property-type" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Type")
), /*#__PURE__*/
_jsx("span", { className: "property-type-warning" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "This cannot be changed after saving")
), /*#__PURE__*/
_jsx(Field, { model: `template.data.properties[${index}].type` }, void 0, /*#__PURE__*/
_jsx("select", { name: "type", id: "property-type", className: "form-control", disabled: !!(property !== null && property !== void 0 && property._id) }, void 0, /*#__PURE__*/
_jsx("option", { value: "date" }, void 0, t('System', 'Single date', null, false)), /*#__PURE__*/
_jsx("option", { value: "multidate" }, void 0, t('System', 'Multiple date', null, false)), /*#__PURE__*/
_jsx("option", { value: "daterange" }, void 0, t('System', 'Single date range', null, false)), /*#__PURE__*/
_jsx("option", { value: "multidaterange" }, void 0, t('System', 'Multiple date range', null, false))
)
)
), /*#__PURE__*/

_jsx(PropertyConfigOptions, { index: index, type: type, canBeFilter: true })
);


const container = connector(FormConfigDateComponent);
export { container as FormConfigDate };